// extracted by mini-css-extract-plugin
export default {"inputBlock":"LandButtonStyle_inputBlock__Ff7yN"};